"use client";

import { useAnalyticsEvents } from "@/hooks/useAnalyticsEvents";
import { usePathname } from "@/hooks/usePathname";
import { pathToRegex } from "@/utils/pathToRegex";
import { useEffect } from "react";

const ROUTE_TO_EVENT_NAME: Record<string, string> = {
  "/": "home",
  "/auth/login": "clerk-login",
  "/account": "account",
  "/account/preferences": "store-language-selection",
  "/orders": "clerk-orders",
  "/search/[suggestion]": "search",
  "/products/[slug]": "pdp",
  "/products/categories/[category]": "category",
  "/products/categories/[category]/[subcategory]": "subcategory",
  "/barcode": "product-scan",
  "/barcode/search": "product-scan-input",
};

export function PageTrackLoader() {
  const pathname = usePathname();
  const { sendPageViewEvent } = useAnalyticsEvents();

  useEffect(() => {
    for (const [routePattern, eventName] of Object.entries(
      ROUTE_TO_EVENT_NAME,
    )) {
      const match = pathToRegex(routePattern).test(pathname);
      if (match) {
        sendPageViewEvent(eventName);
      }
    }
  }, [pathname, sendPageViewEvent]);

  return <></>;
}
